import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

import { Card, CardBody } from 'Components/_theme'

import { EarlyUpgradeEligibleRentalChart } from '../EarlyUpgradeEligibleRentalChart/EarlyUpgradeEligibleRentalChart'
import { organisationDashboardMockEarlyUpgradeEligibleData } from '../OrganisationDashboardDefault/OrganisationDashboardDefault.mocks'

export const DashboardEarlyUpgradeEligibleCard = () => {
  const { count, data, labels } =
    organisationDashboardMockEarlyUpgradeEligibleData

  return (
    <Card className="mb-4">
      <CardBody>
        <Row>
          <Col className="mb-1" xs={6}>
            <p>
              <FormattedMessage id="Admin_dashboard_early_upgrade_text" />
            </p>

            <span className="h4">{count}</span>
          </Col>

          <Col className="d-flex align-items-center" xs={6}>
            <EarlyUpgradeEligibleRentalChart data={data} labels={labels} />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}
